// material-ui
import { useTheme } from '@mui/material/styles';
import logo from 'assets/images/logo2.png'
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();

    return (
      <img height={"75px"} width={'100%'} src={logo}></img>
    );
};

export default Logo;
